import React from "react";
import { classNames } from "../../helpers";

export default function TwRadioBox(props) {
  const { children, className = "", name = "", value = "", errors = {}, error = "", title = "", subTitle = "", displayStyle = "inline-list", radioList = [] } = props
  let inputProps = { ...props }
  delete inputProps.leftIcon
  delete inputProps.rightIcon
  delete inputProps.errors
  delete inputProps.subTitle
  delete inputProps.className
  delete inputProps.value
  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  let inputLableClass = "text-black/[0.6]"
  let inputClass = ""

  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "border-red-900"
  }
  if (props.inputLableClass && props.inputLableClass !== "") {
    inputLableClass += " " + props.inputLableClass
    delete inputProps.inputLableClass
  }
  return (
    <fieldset>
      <label className={classNames("text-sm/6 font-medium text-black/[0.6]", inputLableClass)}>{title}</label>
      {subTitle && (<p className="mt-1 text-sm/6 text-gray-500">{subTitle}</p>)}
      <div className={classNames("mt-2 space-y-6", displayStyle == "inline-list" ? "sm:flex sm:items-center sm:space-x-10 sm:space-y-0" : "sm:flex sm:flex-col sm:justify-center sm:space-x-0 sm:space-y-4")}>
        {radioList.map((radio) => (
          <div key={radio.id} className="flex items-center">
            <input
              // defaultChecked={radio.value == value}
              checked={radio.value == value}
              id={radio.id}
              name={name}
              value={radio.value}
              type="radio"
              className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-brown-coffee checked:bg-brown-coffee focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brown-coffee disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
              {...inputProps}
            />
            <label htmlFor={radio.id} className="ml-3 block text-sm/6 font-medium text-gray-900">
              {radio.title}
            </label>
          </div>
        ))}
      </div>
    </fieldset>
  )
}
